import { render, staticRenderFns } from "./ExcludedProducts.vue?vue&type=template&id=4cc16739&scoped=true"
import script from "./ExcludedProducts.vue?vue&type=script&lang=js"
export * from "./ExcludedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc16739",
  null
  
)

export default component.exports